import { useState, useEffect } from "react";
import sign_up from "../../assets/images/sign_up.png";
// import { createPortal } from "react-dom";
import coffee from "../../assets/images/coffee.png";
import { BtnSmallWhite, DialogBox, Loader, PopUp } from "../../components";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import * as ROUTES from "../../constant/routes";
import { register as Register } from "../../assets/Js/script";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReactTooltip from "react-tooltip";

export default function Signup() {
  const [modals, setModals] = useState({
    successfull: false,
    confirm: false,
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [information, setInformation] = useState(false);

  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [checkBox, setCheckBox] = useState();

  const notify = () => toast.warn("Please accept all term & conditions");

  const notifyErr = (message) => toast.error(message);

  function checkCheckBox(e) {
    const checkData = e.target.checked;
    setCheckBox(checkData);
  }

  async function handleSignup(data) {
    setIsLoaderActive(true);
    const { response } = await Register(data, checkBox);
    if (response?.status === "success") {
      setIsLoaderActive(false);
      setModals((prevState) => ({ ...prevState, successfull: true }));
    } else {
      notifyErr(response?.message ? response?.message : "Something went wrong");
      setCurrentStep(1);
    }
    if (checkBox) {
      setIsLoaderActive(false);
    } else {
      setIsLoaderActive(false);
      notify();
    }
  }

  const {
    register,
    watch,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({ mode: "all" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  function formStepUp(errors) {
    setCurrentStep((curr) => curr + 1);
  }
  function formStepDown() {
    setCurrentStep((curr) => curr - 1);
  }

  useEffect(() => {
    document.addEventListener("click", handleDialogBox);
    function handleDialogBox() {
      setInformation(false);
    }
    return () => {
      document.removeEventListener("onMouse", handleDialogBox);
    };
  }, [information]);

  return (
    <div className="px-8 py-[69px] md:p-[75px] flex flex-col items-start md:items-center">
      <h1 className="flex text-mobile-h1 items-center text-tertiary-dark font-bold md:font-semibold lg:text-[26px] xl:text-[30px] mb-3 text-center">
        <button onClick={() => navigate(-1)} className=" mr-2 md:hidden">
          <svg
            width="13"
            height="20"
            viewBox="0 0 13 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5098 1.8701L10.7298 0.100098L0.839844 10.0001L10.7398 19.9001L12.5098 18.1301L4.37984 10.0001L12.5098 1.8701V1.8701Z"
              fill="#702963"
            />
          </svg>
        </button>
        Create a New Account
      </h1>
      <p className="text-p1 text-left leading-[21px] text-secondary-light font-semibold md:text-h4 md:text-center">
        Revolutionise Distribution of Your Books via ePrakashak
      </p>
      <div className="w-full md:w-[800px]">
        <div className="flex justify-between items-center w-full md:w-[85%] my-8 md:mx-auto md:my-12">
          <div className="relative rounded-full w-[44px] h-[44px] md:w-[60px] md:h-[60px] bg-primary-dark border-2 border-solid border-primary-light flex justify-center items-center">
            <svg
              width="27"
              height="23"
              viewBox="0 0 27 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.833 1.91699H4.94775V21.0837H22.3641V7.66699L15.833 1.91699ZM14.7445 14.3753V18.2087H12.5674V14.3753H9.30185L13.6668 10.542L18.01 14.3753H14.7445ZM14.7445 8.62533V3.35449L20.7314 8.62533H14.7445Z"
                fill="white"
              />
            </svg>

            <p className="hidden md:block text-heading whitespace-nowrap font-semibold text-p1 absolute -bottom-8 -left-3">
              Personal Details
            </p>
          </div>
          <div
            style={{
              background:
                currentStep === 1
                  ? "linear-gradient(90deg, #702963, #fff)"
                  : currentStep > 1
                    ? "#702963"
                    : "#c2c2bd",
            }}
            className="w-[calc(50%-66px)] md:w-[calc(50%-92px)] h-1 bg-primary-dark"
          ></div>
          <div
            className={`relative rounded-full w-[44px] h-[44px] md:w-[60px] md:h-[60px] ${currentStep > 1 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
          >
            <svg
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.375 14.75C14.375 15.1644 14.0534 15.5 13.6562 15.5H9.34375C8.94664 15.5 8.625 15.1644 8.625 14.75V12.5H0V19.25C0 20.45 1.00625 21.5 2.15625 21.5H20.8438C21.9938 21.5 23 20.45 23 19.25V12.5H14.375V14.75ZM20.8438 5H17.25V2.75C17.25 1.55 16.2438 0.5 15.0938 0.5H7.90625C6.75625 0.5 5.75 1.55 5.75 2.75V5H2.15625C1.00625 5 0 6.05 0 7.25V11H23V7.25C23 6.05 21.9938 5 20.8438 5ZM14.375 5H8.625V3.5H14.375V5Z"
                fill="white"
              />
            </svg>

            <p className="hidden md:block text-heading whitespace-nowrap font-semibold text-center text-p1 absolute -bottom-8 -left-10 w-28">
              Business Details
            </p>
          </div>
          <div
            style={{
              background:
                currentStep === 2
                  ? "linear-gradient(90deg, #702963, #fff)"
                  : currentStep > 2
                    ? "#702963"
                    : "#c2c2bd",
            }}
            className="w-[calc(50%-66px)] md:w-[calc(50%-92px)] h-1 bg-primary-dark"
          ></div>
          <div
            className={`relative rounded-full w-[44px] h-[44px] md:w-[60px] md:h-[60px] ${currentStep > 2 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
          >
            <svg
              width="20"
              height="27"
              viewBox="0 0 20 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.666504 2.52083V21.8958C0.666504 22.4097 0.877217 22.9025 1.25229 23.2658C1.62736 23.6292 2.13607 23.8333 2.6665 23.8333H11.3332V21.5503C10.8248 21.266 10.4275 20.8271 10.2028 20.3017C9.97818 19.7763 9.93877 19.1938 10.0907 18.6445C10.2426 18.0952 10.5774 17.6098 11.0431 17.2636C11.5089 16.9174 12.0795 16.7297 12.6665 16.7297C13.2535 16.7297 13.8242 16.9174 14.2899 17.2636C14.7556 17.6098 15.0904 18.0952 15.2423 18.6445C15.3942 19.1938 15.3548 19.7763 15.1302 20.3017C14.9055 20.8271 14.5082 21.266 13.9998 21.5503V23.8333H17.3332C17.8636 23.8333 18.3723 23.6292 18.7474 23.2658C19.1225 22.9025 19.3332 22.4097 19.3332 21.8958V2.52083C19.3332 2.00697 19.1225 1.51416 18.7474 1.15081C18.3723 0.787457 17.8636 0.583328 17.3332 0.583328H2.6665C2.13607 0.583328 1.62736 0.787457 1.25229 1.15081C0.877217 1.51416 0.666504 2.00697 0.666504 2.52083ZM12.6665 20.6042C13.0201 20.6042 13.3593 20.4681 13.6093 20.2258C13.8594 19.9836 13.9998 19.6551 13.9998 19.3125C13.9998 18.9699 13.8594 18.6414 13.6093 18.3991C13.3593 18.1569 13.0201 18.0208 12.6665 18.0208C12.3129 18.0208 11.9737 18.1569 11.7237 18.3991C11.4736 18.6414 11.3332 18.9699 11.3332 19.3125C11.3332 19.6551 11.4736 19.9836 11.7237 20.2258C11.9737 20.4681 12.3129 20.6042 12.6665 20.6042ZM5.99984 5.10416C5.99984 4.93288 6.07008 4.76861 6.1951 4.64749C6.32012 4.52637 6.48969 4.45833 6.66651 4.45833H13.3332C13.51 4.45833 13.6796 4.52637 13.8046 4.64749C13.9296 4.76861 13.9998 4.93288 13.9998 5.10416C13.9998 5.27545 13.9296 5.43972 13.8046 5.56083C13.6796 5.68195 13.51 5.74999 13.3332 5.74999H6.66651C6.48969 5.74999 6.32012 5.68195 6.1951 5.56083C6.07008 5.43972 5.99984 5.27545 5.99984 5.10416ZM3.99984 8.33333C3.82303 8.33333 3.65346 8.40137 3.52843 8.52249C3.40341 8.6436 3.33317 8.80787 3.33317 8.97916C3.33317 9.15045 3.40341 9.31472 3.52843 9.43583C3.65346 9.55695 3.82303 9.62499 3.99984 9.62499H15.9998C16.1767 9.62499 16.3462 9.55695 16.4712 9.43583C16.5963 9.31472 16.6665 9.15045 16.6665 8.97916C16.6665 8.80787 16.5963 8.6436 16.4712 8.52249C16.3462 8.40137 16.1767 8.33333 15.9998 8.33333H3.99984ZM3.33317 11.5625C3.33317 11.3912 3.40341 11.2269 3.52843 11.1058C3.65346 10.9847 3.82303 10.9167 3.99984 10.9167H15.9998C16.1767 10.9167 16.3462 10.9847 16.4712 11.1058C16.5963 11.2269 16.6665 11.3912 16.6665 11.5625C16.6665 11.7338 16.5963 11.8981 16.4712 12.0192C16.3462 12.1403 16.1767 12.2083 15.9998 12.2083H3.99984C3.82303 12.2083 3.65346 12.1403 3.52843 12.0192C3.40341 11.8981 3.33317 11.7338 3.33317 11.5625ZM3.99984 13.5C3.82303 13.5 3.65346 13.568 3.52843 13.6892C3.40341 13.8103 3.33317 13.9745 3.33317 14.1458C3.33317 14.3171 3.40341 14.4814 3.52843 14.6025C3.65346 14.7236 3.82303 14.7917 3.99984 14.7917H15.9998C16.1767 14.7917 16.3462 14.7236 16.4712 14.6025C16.5963 14.4814 16.6665 14.3171 16.6665 14.1458C16.6665 13.9745 16.5963 13.8103 16.4712 13.6892C16.3462 13.568 16.1767 13.5 15.9998 13.5H3.99984Z"
                fill="white"
              />
              <path
                d="M11.333 26.4167V23.8333H13.9997V26.4167L12.6663 25.4479L11.333 26.4167Z"
                fill="white"
              />
            </svg>

            <p className="hidden md:block text-heading whitespace-nowrap font-semibold text-p1 absolute -bottom-8 -left-10">
              Terms and Conditions
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit(handleSignup)}>
          {currentStep === 1 && (
            <>
              <div className="md:py-8 md:px-4 flex justify-between">
                <div className="hidden  w-[46%] h-3/4 md:flex flex-col  ">
                  <p className="text-secondary-dark text-h5 font-[500] text-justify mb-4 leading-tight">
                    Digitize Your Publication!<br />
                    <br />
                    Follow the below steps to create a New Account with ePrakashak and convert your simple PDFs into EBooks
                  </p>
                  <img
                    className="block h-full"
                    src={sign_up}
                    alt="typing on computer"
                  />
                </div>
                <div className="w-full md:w-[333px]">
                  <h3 className="uppercase mb-5 md:mb-3 lg:text-laptop-h3 text-tertiary-dark text-left font-semibold">
                    Personal Details
                  </h3>
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="full_name"
                  >
                    Full Name<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="full_name"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Name"
                    name="full_name"
                    {...register("full_name", {
                      required: true,
                      maxLength: 80,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.full_name && "Please enter the Full Name."}
                  </p>
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="email"
                  >
                    Email Address<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="email"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="email"
                    placeholder="Enter Email Address"
                    name="email"
                    {...register("email", {
                      required: true,
                      pattern: /^\S+@\S+$/i,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.email && "Please enter Valid Email Address"}
                  </p>
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="tel"
                  >
                    Mobile Number<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="tel"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="tel"
                    placeholder="Enter Mobile Number"
                    name="phone"
                    {...register("phone", {
                      required: true,
                      minLength: 10,
                      maxLength: 10,
                      pattern: /^[6-9]\d{9}$/i
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.phone && "Please enter Valid Mobile Number"}
                  </p>
                  <div className="relative">
                    <label
                      className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                      htmlFor="password"
                    >
                      Password<span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      id="password"
                      className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      name="password"
                      {...register("password", {
                        required: true,
                        minLength: 8,
                        maxLength: 16,
                        // validate : (value) => value === getValues("confirm_password"),
                        pattern:
                          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                      })}
                    />
                    <button
                      className="absolute  right-4 top-[50px]"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowPassword((prevState) => !prevState);
                      }}
                    >
                      {showPassword ? (
                        <span data-tip="Hide Password">
                          <svg
                            width="27"
                            height="12"
                            viewBox="0 0 27 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.5465 5.99788C17.5465 7.58673 15.7315 8.87475 13.4927 8.87475C11.2538 8.87475 9.43889 7.58673 9.43889 5.99788C9.43889 4.40901 11.2538 3.12101 13.4927 3.12101C15.7315 3.121 17.5465 4.40903 17.5465 5.99788ZM13.5 0.0078125C11.1819 0.0154292 8.77919 0.433446 6.50466 1.23376C4.81586 1.85246 3.17003 2.72536 1.74137 3.80278C1.03968 4.35276 0.144698 5.14913 0 5.99881C0.0171 6.73483 1.08292 7.6433 1.74137 8.19486C3.08108 9.22996 4.68405 10.0785 6.50466 10.7645C8.62576 11.527 10.9735 11.966 13.5 11.9905C15.8203 11.9827 18.2225 11.5599 20.4945 10.7645C22.1833 10.1458 23.83 9.27228 25.2586 8.19486C25.9603 7.64488 26.8553 6.8485 27 5.99881C26.9829 5.2628 25.9171 4.3543 25.2586 3.80275C23.9189 2.76765 22.3151 1.91976 20.4945 1.23373C18.3745 0.471796 16.0209 0.0357958 13.5 0.0078125ZM13.4983 1.49528C17.011 1.49528 19.8585 3.51185 19.8585 5.99946C19.8585 8.48706 17.011 10.5036 13.4983 10.5036C9.98561 10.5036 7.1381 8.48705 7.1381 5.99946C7.1381 3.51185 9.98561 1.49528 13.4983 1.49528Z"
                              fill="#ADAAAA"
                            />
                          </svg>
                        </span>
                      ) : (
                        <span data-tip="See Password">
                          <svg
                            width="27"
                            height="18"
                            viewBox="0 0 27 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.0689 3.55894C14.5538 3.51767 14.0305 3.49402 13.5 3.48814C11.1819 3.49575 8.77898 3.91342 6.50446 4.71374C4.81565 5.33244 3.17056 6.20589 1.74188 7.28331C1.04022 7.83331 0.144697 8.62968 0 9.47935C0.0171 10.2154 1.08344 11.1238 1.74188 11.6754C3.0816 12.7105 4.68385 13.559 6.50446 14.245C6.56633 14.2672 6.62843 14.2892 6.69067 14.3109L5.00155 16.4959L7.29666 17.5007L19.7035 1.50013L17.4943 0.5L15.0689 3.55894V3.55894ZM20.3077 4.65026L18.6218 6.81454C19.3974 7.56091 19.8578 8.48131 19.8578 9.47935C19.8578 11.967 17.011 13.9838 13.4983 13.9838C13.3465 13.9838 13.1993 13.9716 13.0501 13.9642L11.9344 15.3949C12.449 15.4357 12.9692 15.4654 13.5 15.4706C15.8202 15.4629 18.2218 15.0404 20.4939 14.245C22.1827 13.6263 23.8294 12.7528 25.2581 11.6754C25.9598 11.1254 26.8553 10.329 27 9.47935C26.9829 8.74333 25.9165 7.83486 25.2581 7.28329C23.9184 6.24819 22.3145 5.39974 20.4939 4.71371C20.4324 4.69164 20.3695 4.67179 20.3077 4.65026V4.65026ZM13.4984 4.97497C13.6524 4.97497 13.8052 4.97954 13.9565 4.98717L12.6497 6.66319C10.8156 6.93863 9.43945 8.09453 9.43945 9.47815C9.43945 9.82571 9.52587 10.1585 9.68499 10.4669C9.68517 10.4672 9.68481 10.4678 9.68499 10.4681L8.37486 12.149C7.59746 11.402 7.13889 10.4785 7.13889 9.47933C7.13891 6.99174 9.98568 4.97496 13.4984 4.97497V4.97497ZM17.3002 8.50889L14.3553 12.2882C16.1795 12.0076 17.5457 10.8569 17.5457 9.47815C17.5457 9.13691 17.4538 8.81249 17.3002 8.50889V8.50889Z"
                              fill="#ADAAAA"
                            />
                          </svg>
                        </span>
                      )}
                    </button>
                  </div>
                  {errors.password && (
                    <p
                      className={` mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red] `}
                    >
                      {errors.password && "Password should have "}
                      <br />
                      {errors.password && "- minimum eight characters,"}
                      <br />
                      {errors.password && "- one letter,"}
                      <br />
                      {errors.password &&
                        "- one number and- one special character."}
                      <br />
                    </p>
                  )}
                  <div className="relative">
                    <label
                      className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                      htmlFor="confirm_password"
                    >
                      Confirm Password
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <input
                      id="confirm_password"
                      className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                      type={modals.confirm ? "text" : "password"}
                      placeholder="Enter to Confirm Password"
                      name="confirm_password"
                      {...register("confirm_password", {
                        required: true,
                        minLength: 8,
                        maxLength: 16,
                        validate: (value) => value === getValues("password"),
                      })}
                    />
                    <button
                      className="absolute  right-4 top-[50px]"
                      onClick={(e) => {
                        e.preventDefault();
                        setModals((prev) => ({ ...prev, confirm: !modals.confirm }))
                      }}
                    >
                      {modals.confirm ? (
                        <span data-tip="Hide Confirm Password">
                          <svg
                            width="27"
                            height="12"
                            viewBox="0 0 27 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.5465 5.99788C17.5465 7.58673 15.7315 8.87475 13.4927 8.87475C11.2538 8.87475 9.43889 7.58673 9.43889 5.99788C9.43889 4.40901 11.2538 3.12101 13.4927 3.12101C15.7315 3.121 17.5465 4.40903 17.5465 5.99788ZM13.5 0.0078125C11.1819 0.0154292 8.77919 0.433446 6.50466 1.23376C4.81586 1.85246 3.17003 2.72536 1.74137 3.80278C1.03968 4.35276 0.144698 5.14913 0 5.99881C0.0171 6.73483 1.08292 7.6433 1.74137 8.19486C3.08108 9.22996 4.68405 10.0785 6.50466 10.7645C8.62576 11.527 10.9735 11.966 13.5 11.9905C15.8203 11.9827 18.2225 11.5599 20.4945 10.7645C22.1833 10.1458 23.83 9.27228 25.2586 8.19486C25.9603 7.64488 26.8553 6.8485 27 5.99881C26.9829 5.2628 25.9171 4.3543 25.2586 3.80275C23.9189 2.76765 22.3151 1.91976 20.4945 1.23373C18.3745 0.471796 16.0209 0.0357958 13.5 0.0078125ZM13.4983 1.49528C17.011 1.49528 19.8585 3.51185 19.8585 5.99946C19.8585 8.48706 17.011 10.5036 13.4983 10.5036C9.98561 10.5036 7.1381 8.48705 7.1381 5.99946C7.1381 3.51185 9.98561 1.49528 13.4983 1.49528Z"
                              fill="#ADAAAA"
                            />
                          </svg>
                        </span>
                      ) : (
                        <span data-tip="See Confirm Password">
                          <svg
                            width="27"
                            height="18"
                            viewBox="0 0 27 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.0689 3.55894C14.5538 3.51767 14.0305 3.49402 13.5 3.48814C11.1819 3.49575 8.77898 3.91342 6.50446 4.71374C4.81565 5.33244 3.17056 6.20589 1.74188 7.28331C1.04022 7.83331 0.144697 8.62968 0 9.47935C0.0171 10.2154 1.08344 11.1238 1.74188 11.6754C3.0816 12.7105 4.68385 13.559 6.50446 14.245C6.56633 14.2672 6.62843 14.2892 6.69067 14.3109L5.00155 16.4959L7.29666 17.5007L19.7035 1.50013L17.4943 0.5L15.0689 3.55894V3.55894ZM20.3077 4.65026L18.6218 6.81454C19.3974 7.56091 19.8578 8.48131 19.8578 9.47935C19.8578 11.967 17.011 13.9838 13.4983 13.9838C13.3465 13.9838 13.1993 13.9716 13.0501 13.9642L11.9344 15.3949C12.449 15.4357 12.9692 15.4654 13.5 15.4706C15.8202 15.4629 18.2218 15.0404 20.4939 14.245C22.1827 13.6263 23.8294 12.7528 25.2581 11.6754C25.9598 11.1254 26.8553 10.329 27 9.47935C26.9829 8.74333 25.9165 7.83486 25.2581 7.28329C23.9184 6.24819 22.3145 5.39974 20.4939 4.71371C20.4324 4.69164 20.3695 4.67179 20.3077 4.65026V4.65026ZM13.4984 4.97497C13.6524 4.97497 13.8052 4.97954 13.9565 4.98717L12.6497 6.66319C10.8156 6.93863 9.43945 8.09453 9.43945 9.47815C9.43945 9.82571 9.52587 10.1585 9.68499 10.4669C9.68517 10.4672 9.68481 10.4678 9.68499 10.4681L8.37486 12.149C7.59746 11.402 7.13889 10.4785 7.13889 9.47933C7.13891 6.99174 9.98568 4.97496 13.4984 4.97497V4.97497ZM17.3002 8.50889L14.3553 12.2882C16.1795 12.0076 17.5457 10.8569 17.5457 9.47815C17.5457 9.13691 17.4538 8.81249 17.3002 8.50889V8.50889Z"
                              fill="#ADAAAA"
                            />
                          </svg>
                        </span>
                      )}
                    </button>
                  </div>
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.confirm_password &&
                      "Confirm Password and Password don’t match!"}
                  </p>
                </div>
              </div>
            </>
          )}
          {currentStep === 2 && (
            <>
              <div className="md:py-8 md:px-4 flex justify-between">
                <div className="hidden w-[46%] h-3/4 md:flex flex-col">
                  {/* <p className="text-secondary-dark text-h5 font-[500] text-justify mb-4 leading-tight">
                    Lorem isum dolor sit amet, consectetur adipiscing elit.
                    morbi non pulvinar nunc, quam molestie ornare tellus etiam.
                    Maecenas facilisis semper lacus.
                  </p> */}
                  <img
                    className="block h-full"
                    src={coffee}
                    alt="typing on computer"
                  />
                </div>
                <div className="w-full md:w-[333px]">
                  <h3 className="uppercase mb-6 md:mb-3 lg:text-laptop-h3 text-tertiary-dark text-left font-semibold">
                    Business Details
                  </h3>
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="brand_name"
                  >
                    Brand/ Trade Name<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="brand_name"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Brand/ Trade Name"
                    name="brand_name"
                    {...register("brand_name", {
                      required: true,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.brand_name && "Please enter the Brand/ Trade Name"}
                  </p>

                  {/*unique identifier*/}

                  <label
                    className="relative text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="registered_name"
                  >
                    Business Identifier
                    <span className="text-tertiary-dark" data-tip="Required">
                      *
                    </span>
                    <button
                      onMouseEnter={(e) => {
                        setInformation(!information);
                      }}
                      className=" ml-2"
                    >
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                          fill="#C5C5C5"
                        />
                      </svg>
                    </button>
                    {information && (
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="absolute top-0 left-[13.3rem] w-[250px] h-fit border-[0.5px] p-2 border-solid z-40 border-[rgba(182,182,182,0.33)] bg-[#fbfafb]"
                      >
                        <span className="absolute top-2 -left-3"></span>
                        <p className="font-[500] text-[12px] font-[Cabin] text-[#00000080]">
                          Business Identifier is a 3-5 digit/letter code to
                          easily Identify your brand name.
                          <br />
                          Note, the Business
                          Identifier should start with a letter and must be
                          Unique.
                          <br />
                          Eg:
                          Brand Name: ABC Publications; Identifier: ABCP
                          <br />
                          Brand Name: India Law Publications; Identifier: ILP1{" "}
                          <br />
                        </p>
                        <button
                          onClick={() => {
                            setInformation(false);
                          }}
                          className="absolute top-2 right-1"
                        >
                          <svg
                            width="5"
                            height="5"
                            viewBox="0 0 5 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.80964 4.82838C4.69011 4.93643 4.528 4.99714 4.35897 4.99714C4.18994 4.99714 4.02783 4.93643 3.9083 4.82838L2.50027 3.37344L1.09223 4.8279C1.03322 4.88212 0.962925 4.92524 0.885391 4.95478C0.807858 4.98432 0.724623 4.99969 0.640487 5C0.556352 5.00031 0.472981 4.98555 0.395184 4.95659C0.317387 4.92762 0.246703 4.88502 0.18721 4.83123C0.127716 4.77745 0.0805912 4.71354 0.048552 4.64321C0.0165128 4.57288 0.000193788 4.4975 0.00053638 4.42144C0.000878972 4.34538 0.0178763 4.27013 0.050548 4.20003C0.0832197 4.12994 0.130919 4.06638 0.190895 4.01304L1.65576 2.50048L0.190364 0.986961C0.130388 0.933616 0.0826886 0.870062 0.0500169 0.799967C0.0173452 0.729872 0.000347876 0.654623 5.28423e-06 0.578559C-0.000337307 0.502495 0.0159817 0.427123 0.0480209 0.35679C0.0800601 0.286457 0.127185 0.222554 0.186679 0.168769C0.246172 0.114983 0.316856 0.0723792 0.394653 0.0434138C0.47245 0.0144485 0.555821 -0.000304946 0.639956 4.77726e-06C0.724092 0.000314501 0.807327 0.0156811 0.88486 0.0452183C0.962394 0.0747555 1.03269 0.117879 1.0917 0.1721L2.50027 1.62752L3.9083 0.1721C3.96731 0.117879 4.03761 0.0747555 4.11514 0.0452183C4.19267 0.0156811 4.27591 0.000314501 4.36004 4.77726e-06C4.44418 -0.000304946 4.52755 0.0144485 4.60535 0.0434138C4.68314 0.0723792 4.75383 0.114983 4.81332 0.168769C4.87281 0.222554 4.91994 0.286457 4.95198 0.35679C4.98402 0.427123 5.00034 0.502495 4.99999 0.578559C4.99965 0.654623 4.98265 0.729872 4.94998 0.799967C4.91731 0.870062 4.86961 0.933616 4.80964 0.986961L3.34477 2.50048L4.80964 4.01304C4.8689 4.06655 4.91591 4.1301 4.94798 4.20005C4.98006 4.27001 4.99657 4.34499 4.99657 4.42071C4.99657 4.49643 4.98006 4.57141 4.94798 4.64136C4.91591 4.71132 4.8689 4.77487 4.80964 4.82838Z"
                              fill="black"
                              fill-opacity="0.53"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </label>
                  <input
                    id="identifier"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Business Identifier"
                    name="registered_name"
                    {...register("identifier", {
                      required: true,
                      minLength: 3,
                      maxLength: 5,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.identifier &&
                      "Please enter a Valid Business Identifier"}
                  </p>

                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="registered_name"
                  >
                    Registered Name<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="registered_name"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Registered Name"
                    name="registered_name"
                    {...register("registered_name", {
                      required: true,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.registered_name &&
                      "Please enter a Valid Registered Name"}
                  </p>

                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="registered_address"
                  >
                    Registered Address
                    <span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="registered_address"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Registered Address"
                    name="registered_address"
                    {...register("registered_address", {
                      required: true,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.registered_address &&
                      "Please enter the Registered Address."}
                  </p>

                  {/* <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="domain"
                  >
                    Domain
                    <span className="text-tertiary-light"> (Optional)</span>
                  </label>
                  <input
                    id="domain"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Domain"
                    name="domain"
                    {...register("domain", {})}
                  /> */}
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="gst"
                  >
                    GSTIN<span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    id="gst"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter GST Identification Number"
                    name="gst"
                    {...register("gst", {
                      required: true,
                      pattern:
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.gst && "Please enter a Valid GST Number."}
                  </p>
                  <label
                    className="text-heading-false font-semibold text-tablet-p1 md:text-h5 "
                    htmlFor="website"
                  >
                    Website<span className="text-tertiary-light"> (Optional)</span>
                  </label>
                  <input
                    id="website"
                    className="font-montserrat mb-4 md:mb-6 mt-1 text-heading-false font-[550] text-p1 h-[52px] w-full rounded-[2px] border-1 border-solid border-primary-dark-20 focus:border-primary-dark pl-3"
                    type="text"
                    placeholder="Enter Website"
                    name="website"
                    {...register("website", {
                      required: false,
                      pattern: "",
                    })}
                  />
                  <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[-24px] text-[13px] text-[red]">
                    {errors.website && "Please Enter Your Website Name!"}
                  </p>
                </div>
              </div>
            </>
          )}
          {currentStep === 3 && (
            <>
              <div className="md:py-8">
                <h3 className="uppercase text-tertiary-dark font-bold md:font-semibold text-h5 font-montserrat text-left">
                  User Agreement
                </h3>
                <div
                  style={{
                    boxShadow:
                      "inset -1px -1px 4px rgba(0, 0, 0, 0.08), inset 1px 1px 4px rgba(0, 0, 0, 0.08)",
                  }}
                  className="relative scrollbar scrollbar-thumb-thumb scrollbar-track-track border-[1.5px] h-[628px] border-1 border-solid border-[#E4E3E3] p-6 pr-8 text-left mt-3 md:mt-2"
                >

                  <section id="section-spacing">
                    <div class="container">
                      <p class="text-justify">
                        These Terms and Conditions of Use (the "Terms of Use") apply to the website <a className="underline text-[#1F71DF]" href="https://publisher.eprakashak.in">https://publisher.eprakashak.in</a>, (the "Site"). The Site is the property of ePrakashak ("ePrakashak") and its licensors. BY USING OR ACCESSING THE SITE OR CLICKING ON THE ACCEPT BUTTON, YOU AGREE TO THESE TERMS OF USE; IF YOU DO NOT AGREE, DO NOT USE OR ACCESS THE SITE OR CLICK THE ACCEPT BUTTON.
                      </p>
                      <p class="text-justify">
                        THE AGREEMENT IS EFFECTIVE AS OF THE DATE YOU ACCEPT THESE TERMS (“EFFECTIVE DATE”).
                      </p>
                      <p class="text-justify">
                        ePrakashak reserves the right, at its sole discretion, to change, modify, add or remove these Terms of Use in whole or in part, at any time, without any prior notice. It is your responsibility to check these Terms of Use periodically for any updates or changes. Your continued use of the Site following the updates or changes shall mean that you accept and agree to the changes and updates.
                      </p>
                      <p class="text-justify">
                        Subject to compliance with these Terms of Use, ePrakashak grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use the Site and its Contents within India(“Territory”). The contents of the Site are provided on an "as is" and "as available" basis. ePrakashak shall not be responsible for any errors or omissions contained on the Site and reserve the right to make changes to the Site without any prior notice.
                      </p>
                      <ol>
                        <li>
                          <p class="text-justify">Intellectual Property Rights</p>
                          <p class="text-justify">You acknowledge and understand that ePrakashak either has a license or owns and has exclusive right, title and interest in and to all content on the Site including without limitation, text, graphics, user interfaces, visual interfaces, photographs, trademarks, logos, sounds, software, design, structure, selection, coordination, expression, "look and feel" and arrangement of such content and computer code (collectively, "Content"), and is protected by copyright, patent and trademark laws, and various other intellectual property rights.
                            You also acknowledge that ePrakashak holds ownership and copyrights in the software used to run the Site and any other Software created by it for this purpose.</p>
                        </li>
                        <li>
                          <p class="text-justify">Limitations on use of Website Content</p>
                          <p class="text-justify">Except for the limited licenses expressly granted in these Terms of Use, You have no further rights in or to the Site or its Content, whether express, implied, arising from estoppel or otherwise.</p>
                          <p class="text-justify">Your use of the Site must follow the rules set forth in this Section. Any other use of the Site and its Content is a material breach of this Agreement.
                            <ol type="a">
                              <li><p class="text-justify">The license granted under these Terms of Use are for limited purpose of accessing the Site to (i) upload the eBooks (ii) to generate/purchase Access Codes of any validity in this period (iii) assign the Access Codes (as defined in the Agreement signed with the Publisher (“Hosting Agreement”)) to the users and (iv) amend the eBooks  (“Permitted Purposes”) and you shall not commercially exploit any content on the Site.</p></li>
                              <li><p class="text-justify">You may view the Content and use the related features available on such pages as are required for Permitted Purposes.</p></li>
                              <li><p class="text-justify">You acknowledge and agree that the copyrights in the ebooks/periodicals/journals displayed on the Site (“eBooks”), vests solely in the owners/authors of such eBooks and such owner retains title to and ownership of the original and all copies of the eBooks regardless of the form or media in or on which the original or other copies may exist. You represent and warrant that you have all necessary licenses required to comply with the obligations and to provide licenses and rights to ePrakashak as provided under this Agreement, including without limitation, the rights to upload and amend the eBooks as provided under Section 2(a).</p></li>
                            </ol>
                          </p>
                          <p class="text-justify">Except as expressly set out above, You may not reproduce, modify or in anyway commercially exploit the Site or any of its Contents. In particular, but without limiting the general application of the restrictions contained in the preceding sentence, You may not do any of the following without prior written permission from ePrakashak.</p>
                          <p class="text-justify">
                            <ol type="a">
                              <li><p class="text-justify">You shall not use any part of the Site and/or Content in breach of these Terms of Use, nor may you copy, reverse engineer or reproduce , republish, upload, post, publicly display, encode, translate transmit or distribute in any way (including "mirroring") to any other computer, server, Website or other medium for publication or distribution or for any commercial enterprise, without ePrakashak express prior written consent.</p></li>
                              <li><p class="text-justify">Remove the copyright or trademark notice from any copies of Content made available under on the Site.</p></li>
                              <li><p class="text-justify">You may not attempt to gain unauthorized access to any portion or feature of the Site, or any other systems or networks connected to the Site or to any ePrakashak server, or to any of the services offered on or through the Site, by hacking, password "mining" or any other illegitimate means.</p></li>
                              <li><p class="text-justify">You may not use the Site or any Content for any purpose that is unlawful or prohibited by these Terms of Use, or to solicit the performance of any illegal activity or other activity which infringes the rights of ePrakashak or others.</p></li>
                              <li><p class="text-justify">You may not tamper with or circumvent any security technology included in the Site or its Contents.</p></li>
                            </ol>
                          </p>
                        </li>
                        <li>
                          <p class="text-justify">Accounts, Passwords and Security</p>
                          <p class="text-justify">The Site shall require you to open an account or Log into an account using the first-time login IDs provided to You by your admin. You will provide ePrakashak with accurate, complete registration information while making such account and inform ePrakashak of any changes to such information which may reflect on the account at ePrakashak’s discretion and approval. You are entirely responsible for maintaining the confidentiality of the information you hold for your account, including your password, and for any and all activity that occurs under your account as a result of your failing to keep this information secure and confidential. You agree to notify ePrakashak immediately of any unauthorized use of your account or password, or any other breach of security. You may be held liable for losses incurred by ePrakashak or any other user of or visitor to the Site due to someone else using your ID, password or account as a result of Your failing to keep Your account information secure and confidential.</p>
                          <p class="text-justify">You may not use anyone else’s ID, password or account at any time. ePrakashak cannot and will not be liable for any loss or damage arising from your failure to comply with these obligations. For the purpose of confirming your compliance with the provisions of these Terms of Use, ePrakashak reserves the right to monitor and record activity on the Site, including limiting or restricting, in whole or in part, permanently or temporarily your access to Site and its Content.</p>
                        </li>
                        <li>
                          <p class="text-justify">Privacy Policy</p>
                          <p class="text-justify">ePrakashak’s Privacy Policy applies to use of this Site, and its terms are made a part of these Terms of Use by this reference. To view ePrakashak’s Privacy Policy, <a className="underline text-[#1F71DF]" href="./privacy-policy.html">click here</a>. Additionally, by using the Site, you acknowledge and agree that Internet transmissions are never completely private or secure. You understand that any message or information you send to the Site may be read or intercepted by others, even if there is a special notice that a particular transmission is encrypted.</p>
                        </li>
                        <li>
                          <p class="text-justify">Disclaimer</p>
                          <p class="text-justify">ePRAKASHAK DOES NOT PROMISE THAT THE SITE OR ANY CONTENT, SERVICE OR FEATURE OF THE SITE WILL BE ERROR-FREE OR UNINTERRUPTED, OR THAT ANY DEFECTS WILL BE CORRECTED, OR THAT YOUR USE OF THE SITE WILL PROVIDE SPECIFIC RESULTS. THE SITE AND ITS CONTENT ARE DELIVERED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS. ALL INFORMATION PROVIDED ON THE SITE IS SUBJECT TO CHANGE WITHOUT NOTICE. ePRAKASHAK CANNOT ENSURE THAT ANY FILES ON THE SITE WILL BE FREE OF VIRUSES OR CONTAMINATION OR DESTRUCTIVE FEATURES. ePrakashak DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ePrakashak DISCLAIMS ANY AND ALL LIABILITY FOR THE ACTS, OMISSIONS AND CONDUCT OF ANY THIRD PARTIES IN CONNECTION WITH OR RELATED TO YOUR USE OF THE SITE AND/OR ANY CONTENT. YOU ASSUME TOTAL RESPONSIBILITY FOR YOUR USE OF THE SITESITE. YOUR SOLE REMEDY AGAINST ePrakashak FOR DISSATISFACTION WITH THE SITE OR ANY CONTENT IS TO STOP USING THE SITE OR ANY SUCH CONTENT. THIS LIMITATION OF RELIEF IS A PART OF THE BARGAIN BETWEEN THE PARTIES.</p>
                          <p class="text-justify">The above disclaimer applies to any damages, liability or injuries caused by any failure of performance, error, omission, interruption, deletion, defect, delay in operation or transmission, computer virus, communication line failure, theft or destruction of or unauthorized access to, alteration of, or use, whether for breach of contract, tort, negligence or any other cause of action.</p>
                          <p class="text-justify">ePrakashak reserves the right to do any of the following, at any time, without notice: (1) to modify, suspend or terminate operation of or access to the Site, or any portion of the Site, for any reason; (2) to modify or change the Site, or any portion of the Site, and any applicable policies or terms; and (3) to interrupt the operation of the Site, or any portion of the Site, as necessary to perform routine or non-routine maintenance, error correction, or other changes.</p>
                          <p class="text-justify">The Content provided on this Site does not constitute 'legal advice', and cannot be construed as such. ePrakashak, its sister concerns, employees and associates shall not be held liable for any reliance placed upon material made available from this Site. Please consult a qualified advocate for 'legal advice'.</p>
                        </li>
                        <li>
                          <p class="text-justify">Limitation of Liability</p>
                          <p class="text-justify">ePrakashak shall not be liable for any loss, injury, claim, liability, or damage of any kind resulting from Your use of the Site, its Contents and the interactive areas or any facts or opinions appearing on or through an interactive area.</p>
                          <p class="text-justify">In no event will ePrakashak be liable to you for any special, direct, indirect, consequential, exemplary, incidental or punitive damages, including without limitation lost profits, loss of data, loss of use, interruption of business and lawyer’s fees, even if ePrakashak has been advised of the possibility of such damages.</p>
                          <p class="text-justify">If, notwithstanding the other provisions of these Terms of Use, ePrakashak is found to be liable to you for any damage or loss which arises out of or is in any way connected with your use of the Site or any Content, ePrakashak’s liability shall in no event exceed Rupees One Thousand (Rs. 1000/-)</p>
                        </li>
                        <li>
                          <p class="text-justify">Indemnification</p>
                          <p class="text-justify">You agree to indemnify, defend and hold ePrakashak, its officers, directors, shareholders, predecessors, successors in interest, employees, agents, licensors and any third party information providers, harmless from and against any demands, loss, damages, costs, liability, claims or expenses (including attorneys’ fees), resulting from or arising out of or in connection with your use of the Site or breach of these Terms of Use.</p>
                        </li>
                        <li>
                          <p class="text-justify">Violation of These Terms of Use</p>
                          <p class="text-justify">ePrakashak may disclose any information we have about You (including your identity) if we determine that such disclosure is necessary in connection with any investigation or complaint regarding your use of the Site, or to identify, contact or bring legal action against someone who may be causing injury to or interference with (either intentionally or unintentionally) ePrakashak’s rights or property, or the rights or property of visitors to or users of the Site, including ePrakashak’s customers. ePrakashak reserves the right at all times to disclose any information that ePrakashak deems necessary to comply with any applicable law, regulation, legal process or governmental request. ePrakashak also may disclose your information when ePrakashak determines that applicable law requires or permits such disclosure, including exchanging information with other companies and organizations for fraud protection purposes.</p>
                          <p class="text-justify">You acknowledge and agree that ePrakashak may preserve any transmittal or communication by you with ePrakashak through the Site or any service offered on or through the Site, and may also disclose such data if required to do so by law or ePrakashak determines that such preservation or disclosure is reasonably necessary to (1) comply with legal process, (2) enforce these Terms of Use, (3) respond to claims that any such data violates the rights of others, or (4) protect the rights, property or personal safety of ePrakashak, its employees, users of or visitors to the Site, and the public.</p>
                          <p class="text-justify">You agree that ePrakashak may, in its sole discretion and without prior notice, terminate your access to the Site and/or block your future access to the Site if we determine that you have violated these Terms of Use or other agreements or guidelines which may be associated with your use of the Site. You also agree that any violation by you of these Terms of Use will constitute an unlawful and unfair business practice, and will cause irreparable harm to ePrakashak, for which monetary damages would be inadequate, and you consent to ePrakashak obtaining any injunctive or equitable relief that ePrakashak deems necessary or appropriate in such circumstances. These remedies are in addition to any other remedies ePrakashak may have at law or in equity.</p>
                          <p class="text-justify">You agree that ePrakashak may, in its sole discretion and without prior notice, terminate your access to the Site, for cause, which includes (but is not limited to) (1) requests by law enforcement or other government agencies, (2) a request by you (self-initiated account deletions), (3) discontinuance or material modification of the Site or any service offered on or through the Site, or (4) unexpected technical issues or problems or (5) at sole discretion of ePrakashak.</p>
                        </li>
                        <li>
                          <p class="text-justify">Not Legal Advice</p>
                          <p class="text-justify">The Content on the Site is not intended to and does not constitute legal advice. These Terms of Use or the use of the Site does not form any lawyer-client relationship between You and ePrakashak. The accuracy, completeness, adequacy or currency of the Content is not warranted or guaranteed. Your use of information on the Site or materials linked from the Site is at your own risk.</p>
                        </li>
                        <li>
                          <p class="text-justify">Force Majeure</p>
                          <p class="text-justify">ePrakashak shall not have any liability to You for any interruption or delay in access to the Site irrespective of the cause.</p>
                        </li>
                        <li>
                          <p class="text-justify">Disputes</p>
                          <p class="text-justify">You agree that all matters relating to your access to or use of the Site, including all disputes, will be governed by the laws of India without regard to its conflicts of laws provisions. You agree to the personal jurisdiction by and venue in the state and federal courts in Bangalore, Karnataka, and waive any objection to such jurisdiction or venue.</p>
                          <p class="text-justify">Any claim under these Terms of Use must be brought within one (1) year after the cause of action arises, or such claim or cause of action is barred. No recovery may be sought or received for damages other than out-of-pocket expenses, except that the prevailing party will be entitled to costs and attorneys’ fees. In the event of any controversy or dispute between ePrakashak and you arising out of or in connection with your use of the Site and its Contents, the parties shall submit such controversy or dispute to mediation. If the dispute cannot be resolved through mediation, then the parties shall be free to pursue any right or remedy available to them under applicable law.</p>
                        </li>
                        <li>
                          <p class="text-justify">Miscellaneous</p>
                          <p class="text-justify">If any of the provisions of these Terms of Use are held by a court or other tribunal of competent jurisdiction to be void or unenforceable, such provisions shall be limited or eliminated to the minimum extent necessary and replaced with a valid provision that best embodies the intent of these Terms of Use, so that these Terms of Use shall remain in full force and effect. These Terms of Use constitute the entire agreement between you and ePrakashak with regard to your use of the Site, and any and all other written or oral agreements or understandings previously existing between you and ePrakashak with respect to such use are hereby superseded and cancelled.</p>
                        </li>
                      </ol>

                    </div>
                  </section>

                  <div
                    className="h-[82px] w-full sticky -bottom-[26px] left-0"
                    style={{
                      background:
                        "linear-gradient(13.65deg, rgba(255, 255, 255, 0.88) 54.66%, rgba(255, 255, 255, 0) 136.81%)",
                    }}
                  ></div>
                </div>
              </div>
              <div className="mt-[50px] md:mt-0 flex items-start justify-between">
                <input
                  type="checkbox"
                  onChange={checkCheckBox}
                  checked={checkBox}
                  required
                  className="mt-[5px] w-[30px] h-[27px] bg-primary-dark mr-4"
                />
                <p className="text-justify w-[calc(100%-48px)] text-heading-false font-[500] text-[18px] leading-[24px] md:leading-[21px] mb-6">
                  I confirm that I have read and agree to the{" "}
                  <RouterLink to="https://eprakashak.in/licence-agreement" target="_blank" className="text-tertiary-dark underline ">
                    License Agreement
                  </RouterLink>
                  {"  "} <br />
                  <RouterLink to="https://eprakashak.in/terms-and-conditions" target="_blank" className="text-tertiary-dark underline ">
                    Terms of Use
                  </RouterLink>{" "}
                  and{" "}
                  <RouterLink to="https://eprakashak.in/privacy-policy" target="_blank" className="text-tertiary-dark underline ">
                    Privacy Policy
                  </RouterLink>{" "}
                </p>
              </div>
            </>
          )}

          {currentStep < 3 ? (
            <>
              <div className="hidden md:flex justify-between items-center px-4">
                <BtnSmallWhite
                  type="button"
                  onClick={() =>
                    currentStep === 1 ? navigate(ROUTES.LOG_IN) : formStepDown()
                  }
                >
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2416 6.15081C12.3189 6.23562 12.3802 6.33635 12.422 6.44724C12.4638 6.55813 12.4854 6.67701 12.4854 6.79706C12.4854 6.91712 12.4638 7.03599 12.422 7.14689C12.3802 7.25778 12.3189 7.35851 12.2416 7.44331L9.00832 11L12.2416 14.5566C12.3975 14.728 12.485 14.9605 12.485 15.2029C12.485 15.4453 12.3975 15.6778 12.2416 15.8491C12.0858 16.0205 11.8745 16.1168 11.6541 16.1168C11.4338 16.1168 11.2225 16.0205 11.0666 15.8491L7.24165 11.6416C7.16439 11.5568 7.1031 11.4561 7.06129 11.3452C7.01947 11.2343 6.99794 11.1155 6.99794 10.9954C6.99794 10.8753 7.01947 10.7565 7.06129 10.6456C7.1031 10.5347 7.16439 10.434 7.24165 10.3491L11.0666 6.14165C11.3833 5.79331 11.9166 5.79331 12.2416 6.15081Z"
                      fill="#702963"
                    />
                  </svg>
                  Previous Step
                </BtnSmallWhite>
                <button
                  type="button"
                  disabled={!isValid}
                  onClick={() => formStepUp(errors)}
                  className={`flex  items-center justify-center text-center ${!isValid
                      ? "bg-secondary-dark"
                      : "bg-primary-dark hover:border-2 hover:border-primary-dark hover:border-solid"
                    }   w-[140px] lg:w-150 h-14 text-primary-white`}
                >
                  Next Step
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.75835 6.15081C7.6811 6.23562 7.61981 6.33635 7.57799 6.44724C7.53617 6.55813 7.51465 6.67701 7.51465 6.79706C7.51465 6.91712 7.53617 7.03599 7.57799 7.14689C7.61981 7.25778 7.6811 7.35851 7.75835 7.44331L10.9917 11L7.75835 14.5566C7.60254 14.728 7.515 14.9605 7.515 15.2029C7.515 15.4453 7.60254 15.6778 7.75835 15.8491C7.91417 16.0205 8.1255 16.1168 8.34585 16.1168C8.56621 16.1168 8.77754 16.0205 8.93335 15.8491L12.7584 11.6416C12.8356 11.5568 12.8969 11.4561 12.9387 11.3452C12.9805 11.2343 13.0021 11.1155 13.0021 10.9954C13.0021 10.8753 12.9805 10.7565 12.9387 10.6456C12.8969 10.5347 12.8356 10.434 12.7584 10.3491L8.93335 6.14165C8.61669 5.79331 8.08335 5.79331 7.75835 6.15081Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
              {/* <div className="flex mt-[40px] md:hidden justify-end">
                <button
                  type="button"
                  disabled={!isValid}
                  onClick={formStepUp}
                  className="disabled:opacity-[0.5] bg-primary-dark rounded-full py-[17px] px-[21px]"
                >
                  <svg
                    width="11"
                    height="19"
                    viewBox="0 0 11 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.11773 1.03007C0.983827 1.17717 0.877592 1.35189 0.805107 1.54424C0.732623 1.73659 0.695312 1.94278 0.695312 2.15102C0.695312 2.35926 0.732623 2.56545 0.805107 2.7578C0.877592 2.95015 0.983827 3.12487 1.11773 3.27197L6.72218 9.44117L1.11773 15.6104C0.847653 15.9077 0.695924 16.3109 0.695924 16.7313C0.695924 17.1518 0.847653 17.555 1.11773 17.8523C1.38781 18.1496 1.75412 18.3166 2.13607 18.3166C2.51801 18.3166 2.88432 18.1496 3.1544 17.8523L9.7844 10.5542C9.91831 10.4071 10.0245 10.2323 10.097 10.04C10.1695 9.84765 10.2068 9.64146 10.2068 9.43322C10.2068 9.22498 10.1695 9.01878 10.097 8.82644C10.0245 8.63409 9.91831 8.45937 9.7844 8.31227L3.1544 1.01417C2.60551 0.40997 1.68107 0.40997 1.11773 1.03007Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div> */}
            </>
          ) : currentStep === 3 ? (
            <div className="w-full mt-4 md:mt-2 flex justify-between">
              <BtnSmallWhite
                type="button"
                onClick={() =>
                  currentStep === 1 ? navigate(ROUTES.LOG_IN) : formStepDown()
                }
              >
                <svg
                  width="20"
                  height="22"
                  viewBox="0 0 20 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.2416 6.15081C12.3189 6.23562 12.3802 6.33635 12.422 6.44724C12.4638 6.55813 12.4854 6.67701 12.4854 6.79706C12.4854 6.91712 12.4638 7.03599 12.422 7.14689C12.3802 7.25778 12.3189 7.35851 12.2416 7.44331L9.00832 11L12.2416 14.5566C12.3975 14.728 12.485 14.9605 12.485 15.2029C12.485 15.4453 12.3975 15.6778 12.2416 15.8491C12.0858 16.0205 11.8745 16.1168 11.6541 16.1168C11.4338 16.1168 11.2225 16.0205 11.0666 15.8491L7.24165 11.6416C7.16439 11.5568 7.1031 11.4561 7.06129 11.3452C7.01947 11.2343 6.99794 11.1155 6.99794 10.9954C6.99794 10.8753 7.01947 10.7565 7.06129 10.6456C7.1031 10.5347 7.16439 10.434 7.24165 10.3491L11.0666 6.14165C11.3833 5.79331 11.9166 5.79331 12.2416 6.15081Z"
                    fill="#702963"
                  />
                </svg>
                Previous Step
              </BtnSmallWhite>
              <button
                type="submit"
                // onClick={handleSignup}
                className={`flex  items-center justify-center text-center bg-primary-dark hover:border-2 hover:border-primary-dark hover:border-solid w-[140px] lg:w-150 h-14 text-primary-white`}
              >
                Submit
              </button>
            </div>
          ) : null}
        </form>
      </div>
      <DialogBox show={modals.successfull}>
        <PopUp
          title="Mail Sent!"
          main="Please check your inbox for a verification mail."
          body="An Email has been successfully sent on your registered Email Address, please follow the steps for completing your registration."
          button="Proceed to Login"
          disableClose={true}
          onClick={() => navigate(ROUTES.LOG_IN)}
        // onClose={() => setModals((prev) => ({...prev, successfull: false}))}
        />
      </DialogBox>
      <Loader show={isLoaderActive} />
      <ToastContainer position="top-right" />
      <ReactTooltip
        place="right"
        backgroundColor="#737272"
        type="success"
        effect="solid"
        offset={{ bottom: 0 }}
        delayShow={200}
      />
    </div>
  );
}
